import { useState, useEffect } from 'react';
import { ColumnDefinition } from '../helpers/table/table';

const MOBILE_BREAKPOINT = 767;

export function useMobileColumns(columns: ColumnDefinition[]): ColumnDefinition[] {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  if (!isMobile) return columns;
  return columns.filter(col => !(col as any).isMobileHidden);
}
